import React from 'react';
import { formatBytes } from 'utils';
import FileIcon from '../FileIcon';
import Tooltip from '../Tooltip';
import {
  StyledFileNameText,
  StyledFileNameLink,
  StyledFileSize,
  StyledGrid,
} from './StyledComponents';
import { FileType } from './types';

type FileItemProps = {
  displaySize?: boolean;
  file: FileType;
  extra?: (file: FileType) => React.ReactNode;
  onClick?: (file: FileType) => void;
};

const FileItem: React.FC<FileItemProps> = ({
  displaySize,
  file,
  extra,
  onClick,
}) => (
    <StyledGrid>
      <FileIcon fileType={file.mimetype} />
      <Tooltip title={file.filename || file.name}>
        <div className="text-wrapper">
          {onClick ? (
            <StyledFileNameLink ellipsis block onClick={() => onClick(file)}>
              {file.filename || file.name}
            </StyledFileNameLink>
          ) : (
            <StyledFileNameText ellipsis block>
              {file.filename || file.name}
            </StyledFileNameText>
          )}
          {displaySize && (
            <StyledFileSize
              block
              type={file.status === 'error' ? 'danger' : 'secondary'}
            >
              {file.status === 'error'
                ? 'Upload Failed'
                : formatBytes(file.size)}
            </StyledFileSize>
          )}
        </div>
      </Tooltip>
      {extra && extra(file)}
    </StyledGrid>
  );

export default FileItem;
